/**
 * LayoutPrincipal.js
 *
 * Copiado de hay-hotspot/assets/reactweb/src/pages/Layout/LayoutPrincipal.js (Fase 1.6) — 100%
 * genérico, sem mudanças. Layout raiz (sem guard) — envolve tanto rotas públicas quanto o
 * LayoutAuth.
 */
import { Outlet } from 'react-router';
import React, { Component } from 'react';
import { withRouter } from 'hay-core-react';

class LayoutPrincipal extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#343A40', height: '100%' }}>
        <Outlet {...this.props} />
      </div>
    );
  }
}
export default withRouter(LayoutPrincipal);
